module.exports = __webpack_public_path__ + "webfolder/assets/ebook/ytt-magazine/img/thumbnail-final-page.5acfdb71.jpg";